/* eslint-disable react/static-property-placement */
import React from "react"
import PropTypes from "prop-types"
import * as pacSelectors from "shared/pac/selectors"
import * as supporterSelectors from "shared/profiles/supporter/supporter-profile-selectors"
import * as committeeSelectors from "shared/profiles/political-committee/political-committee-selectors"
import * as orgSelectors from "shared/profiles/organization/organization-profile-selectors"
import { loadSupporterTransactionSummary } from "shared/profiles/supporter/supporter-profile-action-creators"
import { loadCommitteeTransactionSummary } from "shared/profiles/political-committee/political-committee-action-creators"
import { loadOrganizationSummary } from "shared/profiles/organization/organization-profile-action-creators"
import { connect } from "react-redux"

import { HTMLTable } from "quorumdesign"

const supporterTableMapStateToProps = (state, props) => ({
    id: supporterSelectors.selectId(state, props),
    isLoadingTransactionSummary: supporterSelectors.selectIsLoadingTransactionSummary(state, props),
    transactionSummary: supporterSelectors.selectTransactionSummary(state, props),
    rowData: supporterSelectors.selectTransactionSummaryRowData(state, props),
    columnMapping: supporterSelectors.selectTransactionSummaryColumnMapping(state, props),
    shouldLoadTransactionSummary: supporterSelectors.selectShouldLoadTransactionSummary(state, props),
    ledgerSettingsIds: pacSelectors.selectLedgerSettingsListIds(state, props),
})

const politicalCommitteeTableMapStateToProps = (state, props) => ({
    id: committeeSelectors.selectId(state, props),
    isLoadingTransactionSummary: committeeSelectors.selectIsLoadingTransactionSummary(state, props),
    transactionSummary: committeeSelectors.selectTransactionSummary(state, props),
    rowData: committeeSelectors.selectTransactionSummary(state, props),
    columnMapping: committeeSelectors.selectTransactionSummaryColumnMapping(state, props),
    shouldLoadTransactionSummary: committeeSelectors.selectShouldLoadTransactionSummary(state, props),
    ledgerSettingsIds: pacSelectors.selectLedgerSettingsListIds(state, props),
    isCandidateCommittee: committeeSelectors.selectIsCandidateCommittee(state, props),
})

const organizationTableMapStateToProps = (state, props) => ({
    id: orgSelectors.selectId(state, props),
    isLoadingTransactionSummary: orgSelectors.selectIsLoadingTransactionSummary(state, props),
    transactionSummary: orgSelectors.selectTransactionSummary(state, props),
    rowData: orgSelectors.selectTransactionSummaryRowData(state, props),
    columnMapping: orgSelectors.selectTransactionSummaryColumnMapping(state, props),
    shouldLoadTransactionSummary: orgSelectors.selectShouldLoadTransactionSummary(state, props),
    ledgerSettingsIds: pacSelectors.selectLedgerSettingsListIds(state, props),
    fetchTransactionSummaryFailed: orgSelectors.selectFetchTransactionSummaryFailed(state, props),
})

export class HTMLTableSummary extends React.Component {
    static propTypes = {
        // selectors
        id: PropTypes.number.isRequired,
        shouldLoadTransactionSummary: PropTypes.bool.isRequired,
        ledgerSettingsIds: PropTypes.array.isRequired,
        isCandidateCommittee: PropTypes.bool.isRequired,
        rowData: PropTypes.array.isRequired,
        columnMapping: PropTypes.array.isRequired,
        // action creators
        loadTransactionSummary: PropTypes.func.isRequired,
        fetchTransactionSummaryFailed: PropTypes.func.isRequired,
    }

    componentDidMount() {
        if (this.props.shouldLoadTransactionSummary) {
            return this.props.loadTransactionSummary(
                String(this.props.id),
                this.props.ledgerSettingsIds && this.props.ledgerSettingsIds[0],
                this.props.isCandidateCommittee,
            )
        }
    }

    componentDidUpdate() {
        if (this.props.shouldLoadTransactionSummary) {
            return this.props.loadTransactionSummary(
                String(this.props.id),
                this.props.ledgerSettingsIds && this.props.ledgerSettingsIds[0],
                this.props.isCandidateCommittee,
            )
        }
    }

    renderHTMLTable = () => {
        const { rowData, columnMapping, fetchTransactionSummaryFailed } = this.props

        if (fetchTransactionSummaryFailed) {
            // TODO: handle the scenario where no elections would be returned
            return <div> Error fetching transaction summary data </div>
        }

        if (rowData && rowData.length) {
            return (
                <HTMLTable
                    headerText="Transaction Summary"
                    rowData={rowData}
                    columnMapping={columnMapping}
                    boldLastRow={!rowData}
                />
            )
        }
        return null
    }

    render() {
        return <div className="html-table-summary">{this.renderHTMLTable()}</div>
    }
}

export const OrganizationHTMLTableSummary = connect(organizationTableMapStateToProps, {
    loadTransactionSummary: loadOrganizationSummary,
})(HTMLTableSummary)
export const PoliticalCommitteeHTMLTableSummary = connect(politicalCommitteeTableMapStateToProps, {
    loadTransactionSummary: loadCommitteeTransactionSummary,
})(HTMLTableSummary)
export const SupporterHTMLTableSummary = connect(supporterTableMapStateToProps, {
    loadTransactionSummary: loadSupporterTransactionSummary,
})(HTMLTableSummary)
